import screen1 from "../assets/recall-rush-01.png";
import screen2 from "../assets/recall-rush-02.png";
import screen3 from "../assets/recall-rush-03.png";

export default function HeroSec() {
  return (
    <section className="bg-[#fbb325] w-full px-4 py-8 sm:py-16 md:py-16 lg:py-16 overflow-x-hidden h-full">
      <div className="flex flex-col sm:flex-row w-full pb-10">
        <div className="w-full sm:w-1/2 flex flex-col items-center justify-center">
          <img
            alt="Recall rush main logo"
            className="w-32 h-32 text-center self-center rounded-xl mb-6"
            src={require("../assets/recall-rush-logo.png")}
          />
          <h1 className="text-4xl px-6 pt-2 pb-4 font-bold text-white text-center">
            Welcome to Recall Rush – The Perfect Memory Game for Young
            Explorers!
          </h1>
          <p className="text-center px-6 text-white text-1xl">
            Recall Rush is a fun and exciting memory game that helps children
            improve their memory while having a blast! In this game, kids will
            need to match objects after they’re shown in a specific order. The
            goal is to remember the order of objects and find the matches when
            they reappear. With colorful graphics and easy-to-understand
            challenge levels, <span className="font-bold">Recall Rush</span> is
            perfect for young minds.
          </p>
        </div>
        <div className="w-full sm:w-1/2 flex gap-x-5 self-center flex-row items-center justify-center mt-8 sm:mt-0">
          <img
            className="w-3/12 h-auto mt-6 rounded-lg"
            src={screen1}
            alt="app image 1"
          />
          <img
            className="w-4/12 h-auto rounded-lg"
            src={screen2}
            alt="app image 1"
          />
          <img
            className="w-3/12 h-auto mt-6 rounded-lg"
            src={screen3}
            alt="app image 1"
          />
        </div>
      </div>
    </section>
  );
}
